import * as React from 'react';

export const LoadingAnimation: React.FunctionComponent = () => (
    <div className="loading-content">
        <div className="progress-indicator" />
    </div>
);